const fileToEncoded = async (file) => {
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);

  return new Promise((resolve) => {
    fileReader.onload = () => {
      let encoded = fileReader.result.toString().replace(/^data:(.*,)?/, '');
      if (encoded.length % 4 > 0) {
        encoded += '='.repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
  });
};

export default fileToEncoded;
